/**
 * Determinines if DOM functions are available. Typically used to determine if rendering is happening client-side or server-side.
 * @returns A boolean indicating if the DOM is available.
 */
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

export { canUseDOM as default };
